import { isAriaOrDataProp } from '@tanium/coreui-utils';
import { excludeDefaultFiltering } from './styled';

/**
 * Helper for creating `shouldForwardProp` functions.
 *
 * Only the specified props, `data-*`, and `aria-*` props will be forwarded.
 *
 * This type of filtering is rarely needed. Typically `blockProps` is more
 * suitable.
 *
 * @param allowList a list of props to forward
 * @returns a `shouldForwardProp` function
 */
export const allowPropsAndIntrinsics = <T extends string>(allowList: readonly T[]) => {
  const allowSet = new Set<string>(allowList);

  // The intrinsic props are not included in the type-guard for two reasons:
  // - Template string types cannot be used with `Pick` so including them messes
  //   up the resulting styled component's prop types.
  // - `data-*` and `aria-*` props can be specified on any JSX element
  //   regardless of prop types so they do not need to be included in the styled
  //   component's prop types.
  return excludeDefaultFiltering(
    (prop: string): prop is T => allowSet.has(prop) || isAriaOrDataProp(prop),
  );
};
